const utcDateHandler = (dueDate: string) => {
  const auxDate = dueDate.includes("+00:00") ? dueDate.substring(0, dueDate.indexOf("+00:00")) : dueDate;
  const UTCDateWithZ = !auxDate.includes("Z") ? auxDate.concat("Z") : auxDate;
  return UTCDateWithZ;
};
export default utcDateHandler;
